<div class="w-full mx-auto p-6 rounded-lg">
  <h3 class="titre3">{{ 'USERS_MANAGEMENT.INVITE_USERS' | translate }}</h3>

  <app-commun-invite [roleEntites]="roleEntites" [etiquettesDisponibles]="etiquettesAccessibles"
    (emailsChanged)="onEmailsChanged($event)" (entitySelected)="onEntitySelected($event)"
    (etiquettesSelectionnees)="onEtiquettesSelectionnees($event)">
  </app-commun-invite>

  <div class="flex justify-end mt-4">
    <button (click)="onCancel()" type="button"
      class="btn-secondary-novo">
      {{ 'USERS_MANAGEMENT.CANCEL' | translate }}
    </button>
    <button [disabled]="isLoading || !entiteIdSelectionne || courriels === null || courriels.length === 0" (click)="onSubmit()"
      type="submit"
      class="btn-primary-novo disabled:opacity-50 disabled:cursor-not-allowed">
      @if (!isLoading) {
        <span>{{ 'USERS_MANAGEMENT.INVITE' | translate }}</span>
      }
      @if (isLoading) {
        <mat-spinner [diameter]="24" [color]="'accent'"></mat-spinner>
      }
    </button>
  </div>
</div>
